import { FC, useEffect, useState } from "react";
import { isBrowser } from "utils/nookies/utils";

interface IProps {
  render: () => JSX.Element;
  threshold?: number;
}

const DEFAULT_MIN_VALUE = 400;

const LazyLoadWindowScroll: FC<IProps> = ({
  render,
  threshold = DEFAULT_MIN_VALUE,
}) => {
  const isPassThreshold = ()=>isBrowser() && window.scrollY > threshold;
  const [scrolled, setScrolled] = useState<boolean>(isPassThreshold());

  useEffect(() => {
    if (isPassThreshold()) return; // in case initial windows scrollY already passed threshold
    const handleScroll = () => {
      if (isPassThreshold()) {
        setScrolled(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return <>{scrolled && render()}</>;
};
export default LazyLoadWindowScroll;
